import axios from "axios";
import {
  BANNER_LIST_REQUEST,
  BANNER_LIST_SUCCESS,
  BANNER_LIST_FAIL,
  BANNER_ADD_REQUEST,
  BANNER_ADD_SUCCESS,
  BANNER_ADD_FAIL,
  BANNER_UPDATE_REQUEST,
  BANNER_UPDATE_SUCCESS,
  BANNER_UPDATE_FAIL,
  BANNER_DELETE_REQUEST,
  BANNER_DELETE_SUCCESS,
  BANNER_DELETE_FAIL,
  VIDEO_BANNER_LIST_REQUEST,
  VIDEO_BANNER_LIST_SUCCESS,
  VIDEO_BANNER_LIST_FAIL,
  VIDEO_BANNER_UPLOAD_REQUEST,
  VIDEO_BANNER_UPLOAD_SUCCESS,
  VIDEO_BANNER_UPLOAD_FAIL,
  VIDEO_BANNER_DELETE_REQUEST,
  VIDEO_BANNER_DELETE_SUCCESS,
  VIDEO_BANNER_DELETE_FAIL,
  USER_VIDEO_BANNER_LIST_REQUEST,
  USER_VIDEO_BANNER_LIST_SUCCESS,
  USER_VIDEO_BANNER_LIST_FAIL,
  OFFER_BANNER_LIST_REQUEST,
  OFFER_BANNER_LIST_SUCCESS,
  OFFER_BANNER_LIST_FAIL,
  OFFER_BANNER_ADD_REQUEST,
  OFFER_BANNER_ADD_SUCCESS,
  OFFER_BANNER_ADD_FAIL,
  OFFER_BANNER_UPDATE_REQUEST,
  OFFER_BANNER_UPDATE_SUCCESS,
  OFFER_BANNER_UPDATE_FAIL,
  OFFER_BANNER_DELETE_REQUEST,
  OFFER_BANNER_DELETE_SUCCESS,
  OFFER_BANNER_DELETE_FAIL,
  OFFER_BANNER_ACTIVE_REQUEST,
  OFFER_BANNER_ACTIVE_SUCCESS,
  OFFER_BANNER_ACTIVE_FAIL,
  CLEAR_ACTIVE_OFFER_BANNER,
  TOP_OFFER_LIST_REQUEST,
  TOP_OFFER_LIST_SUCCESS,
  TOP_OFFER_LIST_FAIL,
  TOP_OFFER_CREATE_REQUEST,
  TOP_OFFER_CREATE_SUCCESS,
  TOP_OFFER_CREATE_FAIL,
  TOP_OFFER_UPDATE_REQUEST,
  TOP_OFFER_UPDATE_SUCCESS,
  TOP_OFFER_UPDATE_FAIL,
  TOP_OFFER_DELETE_REQUEST,
  TOP_OFFER_DELETE_SUCCESS,
  TOP_OFFER_DELETE_FAIL,
  TOP_OFFER_ACTIVATE_REQUEST,
  TOP_OFFER_ACTIVATE_SUCCESS,
  TOP_OFFER_ACTIVATE_FAIL,
} from "../constants/bannerConstants";

const API_URL = process.env.REACT_APP_API_URL;

// Fetch banners
export const listBanners = () => async (dispatch) => {
  try {
    dispatch({ type: BANNER_LIST_REQUEST });
    const { data } = await axios.get(`${API_URL}/api/banners/banners`);
    dispatch({ type: BANNER_LIST_SUCCESS, payload: data.banners });
  } catch (error) {
    dispatch({
      type: BANNER_LIST_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Add banner
export const addBanner = (bannerData) => async (dispatch, getState) => {
  try {
    dispatch({ type: BANNER_ADD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/api/banners/banner`,
      bannerData,
      config,
    );
    dispatch({ type: BANNER_ADD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: BANNER_ADD_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Update banner
export const updateBanner = (id, bannerData) => async (dispatch, getState) => {
  try {
    dispatch({ type: BANNER_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.put(
      `${API_URL}/api/banners/banner/${id}`,
      bannerData,
      config,
    );
    dispatch({ type: BANNER_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: BANNER_UPDATE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

// Delete banner
export const deleteBanner = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: BANNER_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${API_URL}/api/banners/banners/${id}`, config);

    dispatch({ type: BANNER_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: BANNER_DELETE_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
// add video banner
export const uploadVideoBanner = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: VIDEO_BANNER_UPLOAD_REQUEST });
    const {
      userLogin: { userInfo },
    } = getState();
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/api/banners/addvideobanner`,
      formData,
      config,
    );

    dispatch({ type: VIDEO_BANNER_UPLOAD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: VIDEO_BANNER_UPLOAD_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
//list video banner
export const listVideoBanners = () => async (dispatch, getState) => {
  try {
    dispatch({ type: VIDEO_BANNER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_URL}/api/banners/getvideobanner`,
      config,
    );

    dispatch({
      type: VIDEO_BANNER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: VIDEO_BANNER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const deleteVideoBanner = (videoId) => async (dispatch, getState) => {
  try {
    dispatch({ type: VIDEO_BANNER_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(
      `${API_URL}/api/banners/deletevideobanner/${videoId}`,
      config,
    );

    dispatch({ type: VIDEO_BANNER_DELETE_SUCCESS, payload: videoId });
  } catch (error) {
    dispatch({
      type: VIDEO_BANNER_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const listUserVideoBanners = () => async (dispatch) => {
  try {
    dispatch({ type: USER_VIDEO_BANNER_LIST_REQUEST });
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const { data } = await axios.get(
      `${API_URL}/api/banners/getuservideobanners`,
      config,
    );

    dispatch({ type: USER_VIDEO_BANNER_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: USER_VIDEO_BANNER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};
export const listOfferBanners = () => async (dispatch, getState) => {
  try {
    dispatch({ type: OFFER_BANNER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_URL}/api/banners/offerbanners`,
      config,
    );

    dispatch({
      type: OFFER_BANNER_LIST_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: OFFER_BANNER_LIST_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};
export const addOfferBanner = (bannerData) => async (dispatch, getState) => {
  try {
    dispatch({ type: OFFER_BANNER_ADD_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.post(
      `${API_URL}/api/banners/offerbanner`,
      bannerData,
      config,
    );

    dispatch({
      type: OFFER_BANNER_ADD_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: OFFER_BANNER_ADD_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};
export const updateOfferBanner =
  (id, bannerData) => async (dispatch, getState) => {
    try {
      dispatch({ type: OFFER_BANNER_UPDATE_REQUEST });

      const {
        userLogin: { userInfo },
      } = getState();

      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userInfo.token}`,
        },
      };

      const { data } = await axios.put(
        `${API_URL}/api/banners/offerbanner/${id}`,
        bannerData,
        config,
      );

      dispatch({
        type: OFFER_BANNER_UPDATE_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: OFFER_BANNER_UPDATE_FAIL,
        payload: error.response?.data.message || error.message,
      });
    }
  };
export const deleteOfferBanner = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: OFFER_BANNER_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${API_URL}/api/banners/offerbanner/${id}`, config);

    dispatch({ type: OFFER_BANNER_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: OFFER_BANNER_DELETE_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};
export const getActiveOfferBanner = () => async (dispatch) => {
  try {
    dispatch({ type: OFFER_BANNER_ACTIVE_REQUEST });

    const { data } = await axios.get(`${API_URL}/api/banners/offerbanner`);

    dispatch({
      type: OFFER_BANNER_ACTIVE_SUCCESS,
      payload: Array.isArray(data) ? data[0] : data,
    });
  } catch (error) {
    dispatch({
      type: OFFER_BANNER_ACTIVE_FAIL,
      payload: error.response?.data.message || error.message,
    });
  }
};

export const clearActiveOfferBanner = () => {
  return {
    type: CLEAR_ACTIVE_OFFER_BANNER,
  };
};

export const fetchTopOffers = () => async (dispatch, getState) => {
  try {
    dispatch({ type: TOP_OFFER_LIST_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    const { data } = await axios.get(
      `${API_URL}/api/banners/offerbanners`,
      config,
    );

    dispatch({ type: TOP_OFFER_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: TOP_OFFER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/* CREATE OFFER */
export const createTopOffer = (offerText) => async (dispatch, getState) => {
  try {
    dispatch({ type: TOP_OFFER_CREATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.post(
      `${API_URL}/api/banners/offerbanner`,
      { offerText },
      config,
    );

    dispatch({ type: TOP_OFFER_CREATE_SUCCESS });
    dispatch(fetchTopOffers());
  } catch (error) {
    dispatch({
      type: TOP_OFFER_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/* UPDATE OFFER */
export const updateTopOffer = (id, offerText) => async (dispatch, getState) => {
  try {
    dispatch({ type: TOP_OFFER_UPDATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.put(
      `${API_URL}/api/banners/offerbanner/${id}`,
      { offerText },
      config,
    );

    dispatch({ type: TOP_OFFER_UPDATE_SUCCESS });
    dispatch(fetchTopOffers());
  } catch (error) {
    dispatch({
      type: TOP_OFFER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/* DELETE OFFER */
export const deleteTopOffer = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: TOP_OFFER_DELETE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.delete(`${API_URL}/api/banners/offerbanner/${id}`, config);

    dispatch({ type: TOP_OFFER_DELETE_SUCCESS });
    dispatch(fetchTopOffers());
  } catch (error) {
    dispatch({
      type: TOP_OFFER_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

/* ACTIVATE OFFER */
export const activateTopOffer = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: TOP_OFFER_ACTIVATE_REQUEST });

    const {
      userLogin: { userInfo },
    } = getState();

    const config = {
      headers: {
        Authorization: `Bearer ${userInfo.token}`,
      },
    };

    await axios.put(
      `${API_URL}/api/banners/offerbanner/activate/${id}`,
      {},
      config,
    );

    dispatch({ type: TOP_OFFER_ACTIVATE_SUCCESS });
    dispatch(fetchTopOffers());
  } catch (error) {
    dispatch({
      type: TOP_OFFER_ACTIVATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};